import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Home() {
  // const [isAssetLoaded, setIsAssetLoaded] = useState(false);
  // const [minTimePassed, setMinTimePassed] = useState(false);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setMinTimePassed(true);
  //   }, 1500);
  //   return () => clearTimeout(timer);
  // }, []);

  // const showContent = isAssetLoaded && minTimePassed;

  return (
    <>
      {/* <Header /> */}
      <Helmet>
        <title>Blockcryp | Blockchain, AI & Web3 Development Company</title>
        <meta
          name="description"
          content="Blockcryp delivers cutting-edge blockchain, AI, and Web3 development solutions. Build secure apps, crypto exchanges, DeFi platforms, and smart contracts with us."
        />
        <meta
          name="keywords"
          content="blockchain development company, AI development services, Web3 development company, crypto exchange development, DeFi development solutions, NFT marketplace development, smart contract developers, custom blockchain solutions, AI and blockchain consulting, enterprise Web3 services"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <section className="hero space60 position-relative">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-2 order-lg-1">
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h1 fw-bold text-light mb-4"
              >
                Engineering solutions for tomorrow's world
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                we help you unlock the power of teams and technology, so you can
                confiedity plan, design & build tomorrow. for your customers ,
                for you people, for your entire oranganization.
              </motion.p>
            </div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-6 order-1 order-lg-2"
            >
              <ImageWithSkeleton
                src="assets/images/home/image3.webp"
                alt="Image 1"
                height="600px"
                fetchpriority="high"
              />
            </motion.div>
          </div>
        </div>
      </section>
      {/* ---------- hreo section end ---------- */}

      {/* --------- -- about section start -------- */}
      <section className="space80">
        <div className="container">
          <div className="row align-items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-xl-6 col-lg-5"
            >
              <ImageWithSkeleton
                src="assets/images/home/about.webp"
                alt="Image 1"
                height="600px"
              />
              {/* <img
                src="assets/images/home/about.webp"
                alt="about"
                className="w-100"
              /> */}
            </motion.div>
            <div className="col-xl-6 col-lg-7">
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="about_card"
                  >
                    <div className="card-icon">
                      <i class="fa-solid fa-cubes"></i>
                    </div>
                    <h3 className="text-start heading_h2 fw-bold">40+</h3>
                    <div>
                      <p className="text_20 mb-0">
                        Blockchain Platforms Delivered
                      </p>
                    </div>
                  </motion.div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="about_card"
                  >
                    <div className="card-icon">
                      <i class="fa-solid fa-cubes"></i>
                    </div>
                    <h3 className="text-start heading_h2 fw-bold">25+</h3>
                    <div>
                      <p className="text_20 mb-0">
                        Token Standards Implemented
                      </p>
                    </div>
                  </motion.div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="about_card"
                  >
                    <div className="card-icon">
                      <i class="fa-solid fa-cubes"></i>
                    </div>
                    <h3 className="text-start heading_h2 fw-bold">35+</h3>
                    <div>
                      <p className="text_20 mb-0">Layer 2 Solutions Launched</p>
                    </div>
                  </motion.div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="about_card"
                  >
                    <div className="card-icon">
                      <i class="fa-solid fa-cubes"></i>
                    </div>
                    <h3 className="text-start heading_h2 fw-bold">47+</h3>
                    <div>
                      <p className="text_20 mb-0">Smart Contracts Deployed</p>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------- -- about section end -------- */}

      {/* --------- services section start -------- */}
      <section className="services space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3 text-center"
              >
                Our <span className="text-primary ps-2">Services</span>
              </motion.h2>
            </div>
          </div>

          <ul className="row">
            <li className="col-xl-4 col-lg-6 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="categories-view"
              >
                <i className="fas fa-biohazard" />
                <h3 className="fw-semibold">Blockchain & DeFi</h3>
                <p className="mb-0">
                  Design, develop and launch products using blockchain
                  technology.
                </p>
                {/* <span>01</span> */}
              </motion.div>
            </li>
            <li className="col-xl-4 col-lg-6 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="categories-view"
              >
                <i className="fas fa-biohazard" />
                <h3 className="fw-semibold">Technology Consulting</h3>
                <p className="mb-0">
                  Leverage our global footprint and add technical velocity to
                  your advantage.
                </p>
                {/* <span>01</span> */}
              </motion.div>
            </li>
            <li className="col-xl-4 col-lg-6 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="categories-view"
              >
                <i className="fas fa-biohazard" />
                <h3 className="fw-semibold">Software Engineering</h3>
                <p className="mb-0">
                  Development of new applications including management,
                  maintenance and deployment.
                </p>
                {/* <span>01</span> */}
              </motion.div>
            </li>
            <li className="col-xl-4 col-lg-6 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="categories-view"
              >
                <i className="fas fa-biohazard" />
                <h3 className="fw-semibold">Mobile Apps</h3>
                <p className="mb-0">
                  Build iOS, Android and Cross Platform applications with App
                  store listing compliance.
                </p>
                {/* <span>01</span> */}
              </motion.div>
            </li>
            <li className="col-xl-4 col-lg-6 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="categories-view"
              >
                <i className="fas fa-biohazard" />
                <h3 className="fw-semibold">Cyber Security</h3>
                <p className="mb-0">
                  Enhance cybersecurity posture, increase compliance and build
                  digital resilience.
                </p>
                {/* <span>01</span> */}
              </motion.div>
            </li>
            <li className="col-xl-4 col-lg-6 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="categories-view"
              >
                <i className="fas fa-biohazard" />
                <h3 className="fw-semibold">UI/UX Design</h3>
                <p className="mb-0">
                  and build digital resilience. UI/UX Design Create Design
                  Systems, Interface Designs and User Experiences for your
                  clients.
                </p>
                {/* <span>01</span> */}
              </motion.div>
            </li>
          </ul>
        </div>
      </section>
      {/* --------- services section end -------- */}

      {/* --------- currancy start --------------- */}
      <section className="cuurancy space80">
        <div className="container">
          <div className="row mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3"
              >
                Tailored Solutions Backed by
                <span className="text-primary ps-2">
                  Advanced <br /> Blockchain Networks{" "}
                </span>
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt "
              >
                Our skilled blockchain development team have deep expertise in
                Layer 2, Layer 3, and leading blockchain networks and frameworks
                to deliver customized solutions that boost performance,
                scalability, and meet evolving industry demands.
              </motion.p>
            </div>
          </div>
          <div className="row">
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_01.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      Ethereum{" "}
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_02.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      EOS{" "}
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_03.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      tron
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_04.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      TEzos
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_05.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      hyperledger
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_06.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      Stellar
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>

            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_07.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      matic
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_08.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      Chainlink
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_09.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      ripple
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_10.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      Fantom
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_11.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      Binance
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="col-6 col-sm-4 col-lg-2 mb-4 margin_btm">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="card_box"
              >
                <div className="inner-text">
                  <img src="assets/images/coin/coin_12.png" alt="" />
                  <div>
                    <h3 class="mb-2 mx-auto mb-0 mt-4 text_18 text-center text-white fw-bold">
                      Huobi
                    </h3>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* --------- currancy end --------------- */}

      {/* --------------- cta start  ------------- */}
      <section className="cta space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <div className="text-center">
                <motion.h2
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="text_70 mb-3 text-uppercase fw-semibold talk_heading text-primary"
                >
                  Tell Us Your New Ideas
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  a dynamic design excelling in transforming imaginative
                  concepts into vivid realities through{" "}
                  <br className="d-none d-lg-block"></br> innovative strategies
                  and compelling creative executions.
                </motion.p>

                <a
                  href="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                  target="_blank"
                >
                  <motion.button
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    type="button"
                    className="button talk_btn home_btn theme_btn mt-3"
                  >
                    let's talk <i class="fa-solid fa-square-up-right ms-2"></i>
                  </motion.button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------------- cta end  ------------- */}

      {/* <Footer /> */}
    </>
  );
}
